const PREFIX = 'RowColumn';

const rowColClasses = {
  row: `${PREFIX}-row`,
  rowBorderBottom: `${PREFIX}-rowBorderBottom`,
  column: `${PREFIX}-column`,
  fieldRoot: `${PREFIX}-fieldRoot`,
  cell: `${PREFIX}-cell`,
  labelText: `${PREFIX}-labelText`,
  labelDense: `${PREFIX}-labelDense`,
  highlighted: `${PREFIX}-highlighted`,
  checkboxLabel: `${PREFIX}-checkboxLabel`,
  icon: `${PREFIX}-icon`,
  S: `${PREFIX}-S`,
  XS: `${PREFIX}-XS`,
  A: `${PREFIX}-A`,
  X: `${PREFIX}-X`,
  frequencyCount: `${PREFIX}-frequencyCount`,
  barContainer: `${PREFIX}-barContainer`,
  bar: `${PREFIX}-bar`,
  barSelected: `${PREFIX}-barSelected`,
  barWithCheckbox: `${PREFIX}-barWithCheckbox`,
  barSelectedWithCheckbox: `${PREFIX}-barSelectedWithCheckbox`,
  excludedTextWithCheckbox: `${PREFIX}-excludedTextWithCheckbox`,
};

export default rowColClasses;
